//this function takes the value from an event that is most likely an object and returns the id of that object
//It also handles null and undefined values and returns an empty string
//If the value is defined and isn't an object, it returns the value (this handles strings and numbers)
//If false is passed in, it returns false. This handles checkboxes.
export const getValueFromEventValue = (eventValue) => {
  if(eventValue === null || eventValue === undefined) {
    return '';
  }
  if (typeof eventValue === 'object') {
    return eventValue.id || '';
  }
  return eventValue;
};